import { CommonModule, TitleCasePipe } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';
import { TENANTS_INFO } from 'apps/ff-frontend/src/app/state/app.state';
import { NotificationLevel, NotificationSubscriptionType } from 'libs/enum/src/lib/enum.common';
import { StaffNotificationResponse } from 'libs/models/src/lib/staff';
import { TENANT_MODEL, TENANTSINTERFACE } from 'libs/models/src/lib/tenant';
import { DayAgoPipe } from 'libs/shared/src/lib/filters/dayago.pipe';
import { AvatarModule } from 'primeng/avatar';
import { BadgeModule } from 'primeng/badge';
import { ButtonModule } from 'primeng/button';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { OverlayModule } from 'primeng/overlay';
import { PopoverModule } from 'primeng/popover';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { DrawerModule } from 'primeng/drawer';
import { StyleClassModule } from 'primeng/styleclass';
import { BehaviorSubject } from 'rxjs';
import { ClientInfoSidebarComponent } from '../client-info-sidebar/client-info-sidebar.component';
import { FormsModule } from '@angular/forms';
import { StaffNotificationService, ToastMessageService } from '@fitness-force/api';
import { RouteStateService } from 'libs/shared/src/lib/router-guard/route-state-service.service';
import Statsig from 'statsig-js';
import { Router } from '@angular/router';
import { ShortNamePipe } from '@fitness-force/pipes/short-name';
import { MessageModule } from 'primeng/message';
@Component({
  selector: 'staff-notification-sidebar',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule,
    DrawerModule,
    StyleClassModule,
    ToggleSwitchModule,
    ButtonModule,
    OverlayModule,
    ScrollPanelModule,
    AvatarModule,
    BadgeModule,
    MessageModule,
    DayAgoPipe,
    PopoverModule,
    TitleCasePipe,
    ShortNamePipe,
    ClientInfoSidebarComponent
  ],
  templateUrl: './staff-notification-sidebar.component.html',
  styleUrl: './staff-notification-sidebar.component.css',
  providers: [],
  changeDetection: ChangeDetectionStrategy.Default,
})
export class StaffNotificationSidebarComponent implements OnInit{
  @Input('showSidebar') showSidebar: boolean = false;
  @Input('activeStaffId') activeStaffId: number = 0;
  @Input('notificationData') notificationData = new BehaviorSubject<StaffNotificationResponse[]>([]);
  @Output('closeSidebar') closeSidebar: EventEmitter<{close:boolean, reloadData:boolean}> =new EventEmitter();

  directNotifications: boolean = false;
  tenantAccess: TENANT_MODEL[] = [];
  tenantId: number = 0;
  groupByTenantData: any;
  showClientSidebar: boolean = false;
  activeClientId: number = 0;
  showOnlyData:number = 2;
  showInfo: boolean = false;

  currentTenantNotifications = new BehaviorSubject<StaffNotificationResponse[]>([])
  otherTenantNotifications = new BehaviorSubject<any>([]);

  allNotifications: StaffNotificationResponse[] = [];
  interactionId: number=0;
  twoWayNotificationEnabled: boolean = false;

  constructor(private store: Store, public cdr : ChangeDetectorRef,
     private staffnotificationService: StaffNotificationService,
     public toastMessageService: ToastMessageService,
     private routerStateService: RouteStateService,
     private router: Router) {
     }


  ngOnInit() {
    this.store.select(TENANTS_INFO).subscribe((tenant: TENANTSINTERFACE) => {
      this.tenantId = tenant.selected_tenant.id;
      this.tenantAccess = tenant.accessed_tenant;
    });

    if(Statsig.checkGate("show_staff_2way_message_notifciation")){
      this.twoWayNotificationEnabled = true;
    }
    this.notificationData$();
    this.otherTenantNotificationData$();

    this.routerStateService.staffNotifications$.subscribe((data) => {
      this.allNotifications = data;
      this.notificationData.next(data);
      this.notificationData$();
      this.otherTenantNotificationData$();
    });
  }

  closeNotificationSidebar() {
    this.showSidebar = false;
    this.closeSidebar.emit({close:true, reloadData:false});
    this.cdr.detectChanges();
  }

  getIcon(type: StaffNotificationResponse) {
    var data =
      NotificationSubscriptionType[
        type.subscription_topic.toString() as keyof typeof NotificationSubscriptionType
      ];
    switch (data) {
      case NotificationSubscriptionType.IncomingEmail:
        return 'fa fa-envelope text-xs';
      case NotificationSubscriptionType.IncomingSMS:
        return 'fa fa-comment text-xs';
      case NotificationSubscriptionType.IncomingWhatsApp:
        return 'fab fa-whatsapp';
      default:
        return '';
    }
  }

  getClass(type: StaffNotificationResponse) {
    var data =
      NotificationSubscriptionType[
        type.subscription_topic.toString() as keyof typeof NotificationSubscriptionType
      ];
    switch (data) {
      case NotificationSubscriptionType.IncomingEmail:
        return 'bg-orange-500';
      case NotificationSubscriptionType.IncomingSMS:
        return 'bg-pink-500';
      case NotificationSubscriptionType.IncomingWhatsApp:
        return 'whatsapp-bg';
      default:
        return '';
    }
  }

  getReplyText(type: StaffNotificationResponse) {
    var data =
      NotificationSubscriptionType[
        type.subscription_topic.toString() as keyof typeof NotificationSubscriptionType
      ];
    switch (data) {
      case NotificationSubscriptionType.IncomingEmail:
        return 'EMAIL_REPLY';
      case NotificationSubscriptionType.IncomingSMS:
        return 'SMS_REPLY';
      case NotificationSubscriptionType.IncomingWhatsApp:
        return 'WHATSAPP_REPLY';
      default:
        return 'NO_REPLY';
    }
  }

  notificationData$() {
    var notificationData:any = this.notificationData.value;;
    if(this.directNotifications) {
      notificationData = notificationData.filter((o: { level: NotificationLevel; }) => o.level == NotificationLevel.Self || o.level.toString() == NotificationLevel[NotificationLevel.Self]);
    }
    notificationData = notificationData
    .filter((o: { tenant_id: number; }) => o.tenant_id == this.tenantId)
    .sort((a: { created_date: string | number | Date; }, b: { created_date: string | number | Date; }) => new Date(b.created_date).getTime() - new Date(a.created_date).getTime());
    this.currentTenantNotifications.next(notificationData);
  }

  otherTenantNotificationData$() {
    var notificationData = this.notificationData.value;
    notificationData = notificationData
      .filter(o => o.tenant_id !== this.tenantId)
      .sort((a, b) => new Date(b.created_date).getTime() - new Date(a.created_date).getTime());
    const groupedByTenant:any = notificationData.reduce((acc:any, curr) => {
      if (!acc[curr.tenant_id]) {
        acc[curr.tenant_id] = [];
      }
      acc[curr.tenant_id].push(curr);
      return acc;
    }, {});
    this.groupByTenantData = Object.keys(groupedByTenant).map(key => ({
      tenantId: key,
      showInfo: false,
      notifications: groupedByTenant[key]
    }));
    this.otherTenantNotifications.next(this.groupByTenantData);
  }

  markAsDelete(type: StaffNotificationResponse) {
    this.staffnotificationService.markNotificationAsDelete(type.tenant_id,type.id).subscribe({
      next: (data) => {
        var newData = this.notificationData.value;
        newData.map((o) => { if(o.id == type.id) { o.is_deleted = true; } }); 
        this.notificationData.next(
          newData //this.notificationData.getValue().filter((o) => o.id ! == type.id)
        );
        this.notificationData$();
        this.toastMessageService.showSuccess('Notification Deleted Successfully');
        this.closeSidebar.emit({close:false, reloadData:true});
        this.cdr.detectChanges();
      },
      error: (error) => {
        this.toastMessageService.showError(error);
        this.cdr.detectChanges();
      },
    });
  }

  markAsRead(type: StaffNotificationResponse) {
    const payload = {
      "id": [
        type.id
      ]
    }
    this.staffnotificationService.markNotificationAsRead(type.tenant_id,payload).subscribe({
      next: (data) => {
        var newData = this.notificationData.value;
        newData.map((o) => { if(o.id == type.id) { o.is_read = true; } }); 
        this.notificationData.next(
          newData
        );
        this.notificationData$();
        // this.closeSidebar.emit({close:false, reloadData:true});
        this.cdr.detectChanges();
      },
      error: (error) => {
        this.toastMessageService.showError(error);
        this.cdr.detectChanges();
      },
    });
  }

  markAllAsRead() {
    const payload = {
      "id": this.notificationData.value.filter(o => o.tenant_id == this.tenantId).map(o => o.id)
    }
    this.staffnotificationService.markNotificationAsRead(this.tenantId,payload).subscribe({
      next: (data) => {
        var newData = this.notificationData.value;
        newData.map((o) => {  o.is_read = true; }); 
        this.notificationData.next(
          newData //this.notificationData.getValue().filter((o) => o.tenant_id !== this.tenantId)
        );
        this.closeSidebar.emit({close:false, reloadData:true});
        this.cdr.detectChanges();
      },
      error: (error) => {
        this.toastMessageService.showError(error);
        this.cdr.detectChanges();
      },
    });
  }

  showDirectNotifications(directNotification:boolean) {
    this.directNotifications = !directNotification;
    if(this.directNotifications) {
      let data = this.notificationData.value.filter(o => o.tenant_id == this.tenantId && (o.level == NotificationLevel.Self || o.level.toString() == NotificationLevel[NotificationLevel.Self]));
      this.currentTenantNotifications.next(data.sort((a, b) => new Date(b.created_date).getTime() - new Date(a.created_date).getTime()));
      this.cdr.detectChanges();
    }
    else{
      this.notificationData$();
      this.cdr.detectChanges();
    }
    
  }

  getTenantName(tenantId: number) {
    var tenant = this.tenantAccess.find((x) => x.id == tenantId);
    return tenant ? tenant.name_primary_language : '';
  }

  loadMoreNotifications()
  {
    this.showOnlyData = this.showOnlyData + 2;
    this.cdr.detectChanges();
  }

  remainingCount():number{
    return Math.max(0,this.otherTenantNotificationData$.length - this.showOnlyData);
  }

  isDirectNotification(type: StaffNotificationResponse) {
    return (type.level == NotificationLevel.Self || type.level.toString() == NotificationLevel[NotificationLevel.Self] );
  }

  openClientSidebar(type: StaffNotificationResponse) {
    this.activeClientId = type.client.id;
    this.interactionId = type.payload.interaction_id  || 0;
    if(this.twoWayNotificationEnabled){
      this.router.navigate(['/crm/inbox', this.activeClientId]);
    }
    else{
      this.showClientSidebar = true;
    }

    this.markAsRead(type);

  }

  CloseSidebar(event:any)
  {
    this.showClientSidebar = false;
  }

  trackByFn(index: number, item: any): any {
    return item.tenantId; // or any unique identifier for the notification
  }

  toggleInfo(data:any)
  {
   this.otherTenantNotifications.next(this.otherTenantNotifications.value.map((o:any) => { if(o.tenantId == data.tenantId) { o.showInfo = !o.showInfo; } return o; }));
  }

  public get subscriptionType() {
    return NotificationSubscriptionType;
  }

  getInteractionContent(message: string): string {
    if (!message) return '';
  
    try {
      // Split at hidden content marker
      const hiddenContentMarker = '-- Hidden Content Begins --';
      const parts = message.split(hiddenContentMarker);
      
      // Get the main content (part before hidden content)
      let mainContent = parts[0].trim();
      if(mainContent == '' || mainContent == null)
      {
        mainContent = parts[1].trim();
      }
      // Remove email signature block (everything after first occurrence of multiple newlines)
      const signaturePattern = /\n\s*(?:thankyou|regards|best|sincerely|yours|warm|thanks|--)/i;
      const signatureMatch = mainContent.match(signaturePattern);
      
      if (signatureMatch) {
        mainContent = mainContent.substring(0, signatureMatch.index).trim();
      }
  
      // Clean up the content
      return this.cleanupMessageContent(mainContent);
  
    } catch (error) {
      console.error('Error parsing message:', error);
      return message;
    }
  }
  
  private cleanupMessageContent(content: string): string {
    return content
      // Remove email headers
      .replace(/^(?:From|To|Sent|Date|Subject):.+$/gm, '')
      
      // Remove quoted text
      .replace(/^>.*$/gm, '')
      
      // Remove email signatures
      .replace(/^--\s*$/m, '')
      
      // Remove links
      .replace(/<https?:\/\/[^>]+>/g, '')
      
      // Remove asterisks (often used for formatting)
      .replace(/\*([^*]+)\*/g, '$1')
      
      // Remove contact info blocks
      .replace(/(?:Mobile|Phone|Tel|Email|Website|Address):\s*[^\n]+\n?/g, '')
      
      // Remove disclaimer text
      .replace(/IMPORTANT:[\s\S]*?(?=\n\n|$)/, '')
      
      // Remove excessive whitespace and newlines
      .replace(/\n{3,}/g, '\n\n')
      .replace(/\s+/g, ' ')
      
      // Final cleanup
      .trim();
  }
  
}
